import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Chip, Paper, Stack } from '@mui/material'
import API from '../../../services/API'
import CustomDataGrid from '../../../components/DataGrid/CustomDataGrid'
import historyColumns from './historyColumns'
import MakeReadyTrends from './MakeReadyTrends'

const SOURCE_FILTERS = [
  { key: '', label: 'All' },
  { key: 'check', label: 'Full Check' },
  { key: 'quick_add', label: 'Quick Top-up' },
]

const MakeReadyHistory = () => {
  const navigate = useNavigate()
  const [history, setHistory] = useState([])
  const [loading, setLoading] = useState(true)
  const [totalCount, setTotalCount] = useState(0)
  const [sourceFilter, setSourceFilter] = useState('')
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 50,
  })

  const loadHistory = () => {
    setLoading(true)
    API.get('/makeready/history', {
      params: {
        page: paginationModel.page,
        count: paginationModel.pageSize,
        ...(sourceFilter ? { source: sourceFilter } : {}),
      },
    })
      .then((res) => {
        if (res.status === 200) {
          setHistory(res.data.history)
          setTotalCount(res.data.totalCount)
        }
      })
      .catch((e) => console.error(e))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    loadHistory()
  }, [paginationModel, sourceFilter])

  return (
    <Stack gap={2}>
      <MakeReadyTrends />

      <Stack direction="row" flexWrap="wrap" gap={1}>
        {SOURCE_FILTERS.map(({ key, label }) => (
          <Chip
            key={key || 'all'}
            label={label}
            onClick={() => {
              setSourceFilter(key)
              setPaginationModel((prev) => ({ ...prev, page: 0 }))
            }}
            color={sourceFilter === key ? 'primary' : 'default'}
            variant={sourceFilter === key ? 'filled' : 'outlined'}
          />
        ))}
      </Stack>

      <Paper>
        <CustomDataGrid
          rows={history}
          getRowId={(row) => row._id}
          columns={historyColumns()}
          onRowClick={({ row }) =>
            navigate(
              `/make-ready/${row?.makeReadyInventory?.vehicleId?._id ?? row?.makeReadyInventory?.assetId?._id}`,
            )
          }
          autoHeight
          loading={loading}
          pageSizeOptions={[25, 50, 100]}
          pagination
          paginationMode="server"
          rowCount={totalCount}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          disableRowSelectionOnClick
        />
      </Paper>
    </Stack>
  )
}

export default MakeReadyHistory
